import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import AccountList from './pages/accounts/AccountList';
import CommandList from './pages/commands/CommandList';
import CommandDetail from './pages/commands/CommandDetail';
import WecomChatList from './pages/wecom-chats/WecomChatList';
import Portal from './pages/portal/Portal';
import PortalLogin from './pages/portal/Login';
import PortalRegister from './pages/portal/Register';
import NoPermission from './pages/portal/NoPermission';
import PortalGuard from './pages/portal/PortalGuard';
import AdminGuard from './pages/portal/AdminGuard';
import LoginEntryGate from './pages/portal/LoginEntryGate';
import Forbidden from './pages/admin/Forbidden';
import CompletePage from './pages/complete/CompletePage';
import { PortalAccountProvider } from './contexts/PortalAccountContext';

const App = () => {
  return (
    // PortalAccountProvider 挂在最外层：
    //  - 门户账号 profile 仅存在内存 Context，避免用户改 localStorage 伪造身份；
    //  - 后台管理页也在 Provider 下，但内部不会消费，无副作用；
    //  - 刷新页面时 LoginEntryGate / PortalGuard 会重新拉 /portal/me 兜底恢复。
    <PortalAccountProvider>
      <BrowserRouter>
        <Routes>
          {/* 根路径：先探测身份 → 已登录按身份分流；未登录跳登录页 */}
          <Route
            path="/"
            element={
              <LoginEntryGate>
                <Navigate to="/portal/login" replace />
              </LoginEntryGate>
            }
          />

          {/* 客户端门户：微信登录鉴权 */}
          <Route
            path="/portal/login"
            element={
              <LoginEntryGate>
                <PortalLogin />
              </LoginEntryGate>
            }
          />
          {/*
            注册页：扫码检测账号——已注册直接登录，未注册自动创建 PENDING 账号。
            同样套 LoginEntryGate：已登录用户访问注册页自动跳回 /portal，避免误触。
          */}
          <Route
            path="/portal/register"
            element={
              <LoginEntryGate>
                <PortalRegister />
              </LoginEntryGate>
            }
          />
          <Route path="/portal/no-permission" element={<NoPermission />} />
          {/* 后台无权限页：当前太湖用户不在 ADMIN_USERS 名单时跳转到此 */}
          <Route path="/403" element={<Forbidden />} />
          {/*
            指令完成页：通过企微子群按钮跳转。
            - 路径落在 `/portal/complete` 内网子路径：企微客户端跳转时会命中内网 portal 域，
              智能网关可注入 `x-tai-identity` 作为免登登录信息。
            - 该路由**不套 PortalGuard**（不需要微信登录）：token 是唯一入场券。
            - 必须在下面 `path="/portal"` 的 PortalGuard 之前注册，React Router 会优先命中更具体的 `/portal/complete`。
          */}
          <Route path="/portal/complete" element={<CompletePage />} />
          <Route
            path="/portal"
            element={
              <PortalGuard>
                <Portal />
              </PortalGuard>
            }
          />

          {/* 后台管理：太湖鉴权 + 客户端门户用户禁入（持有 portal token 一律踢到 /portal） */}
          <Route
            path="/"
            element={
              <AdminGuard>
                <Layout />
              </AdminGuard>
            }
          >
            <Route path="commands" element={<CommandList />} />
            <Route path="commands/detail" element={<CommandDetail />} />
            <Route path="accounts" element={<AccountList />} />
            <Route path="wecom-chats" element={<WecomChatList />} />
          </Route>

          {/* 兜底：未匹配到的路径统一回登录页 */}
          <Route path="*" element={<Navigate to="/portal/login" replace />} />
        </Routes>
      </BrowserRouter>
    </PortalAccountProvider>
  );
};

export default App;
